import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { ServiceDetail } from '../data/services';
type ServiceCardProps = {
  service: ServiceDetail;
  featured?: boolean;
};
const accentClasses = {
  teal: 'bg-[#dceee7] text-[#286151]',
  ochre: 'bg-[#f4e7c3] text-[#8b5c18]',
  coral: 'bg-[#f4dfd8] text-[#a24e38]'
};
export function ServiceCard({
  service,
  featured = false
}: ServiceCardProps) {
  const Icon = service.icon;
  return <article className={`flex h-full flex-col border border-stone-200 p-6 sm:p-7 ${featured ? 'bg-[#172820] text-white' : 'bg-white text-[#172820]'}`} data-id="element-132" data-mp="34jzsxtogroam">
      <div className={`grid h-11 w-11 place-items-center rounded-sm ${featured ? 'bg-[#326f5e] text-[#dceee7]' : accentClasses[service.accent]}`} data-id="element-133" data-mp="39bhuojyb9swn">
        <Icon className="h-5 w-5" aria-hidden="true" data-id="element-134" data-mp="3j9ozy5j8mmit" />
      </div>
      <p className={`mt-8 text-xs font-bold uppercase tracking-[0.16em] ${featured ? 'text-[#a8d5c3]' : 'text-stone-500'}`} data-id="element-135" data-mp="3o807uapz2mye">
        {service.eyebrow}
      </p>
      <h3 className="mt-3 text-2xl font-semibold tracking-tight" style={{
      fontFamily: 'var(--font-display)'
    }} data-id="element-136" data-mp="247pfvxk8gjll">
        {service.shortTitle}
      </h3>
      <p className={`mt-4 max-w-md text-sm leading-6 ${featured ? 'text-stone-300' : 'text-stone-600'}`} data-id="element-137" data-mp="1ubw5oktzl26z">
        {service.description}
      </p>
      <Link to={`/services/${service.slug}`} className={`group mt-8 inline-flex items-center gap-2 text-sm font-semibold ${featured ? 'text-[#dceee7]' : 'text-[#286151]'}`} data-id="element-138" data-mp="2n0jma33sj3e7">
        Explore the service{' '}
        <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-139" data-mp="2d8xaa4jmp0ae" />
      </Link>
    </article>;
}